<template>
  <div id="messageGroup" ref="messageRef">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>          
        </v-flex>
      </v-layout>
    </v-container>  
    <v-form ref="formAdd">   
      <v-container class="-border">
        <v-layout wrap>
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout>
            <v-flex class="xs12 sm6 md7">
            <v-text-field 
                label="Group Name" 
                v-model="group.name" 
                class="required pr-4 pl-4" 
                @input="changedData" 
                :rules="[rules.NameRule]">
            </v-text-field>
            </v-flex>
        </v-layout>
        <v-layout v-if="group.human.length" class="mr-4 ml-4">
          <v-flex class="xs12 sm6 md7 pa-0">
            <label>Selected Memebers</label>
            <template v-for="(to, i) in group.human">
                <v-chip
                :key="i"
                v-if="true"
                class=""
                close
                @input="removeItem(to)"
                >
                {{ to.name }}
                </v-chip>
          </template>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
              <v-autocomplete
                return-object
                v-model="group.human"
                @change="changedData" 
                @keyup.enter="searchFamilies" 
                :items="recipientList" 
                item-text="name"
                item-value="id"
                label="search Members"
                :rules="[rules.toRule]"
                deletable-chips
                small-chips
                multiple
                hide-no-data
                placeholder="Search by Name / Nickname / PPN / Agency"
                hint="Type atleast 3 characters to search"
                id="recipientSearch"
                :search-input.sync="searchInput"
                class="required pr-4 pl-4">
                <v-icon slot="append" @click="searchFamilies"> search </v-icon>
              </v-autocomplete>
          </v-flex>
        </v-layout>
         <v-layout>
          <v-flex class="xs12 sm6 md7">
          <v-combobox class="pr-4 pl-4" persistent-hint :rules="[rules.multipleEmail]" @change="changedData" v-model="group.emails" label="Emails" hint="emails - hit enter to add new" multiple deletable-chips small-chips></v-combobox>
          </v-flex>
        </v-layout>   
        <v-layout class="editor-button-container">
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store  */
import swal from 'sweetalert2';
import { getCollection, create } from '../../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'messageGroup',
  data: () => ({
    entity: 'MessageGroup',
    selectedData: false,
    searchInput: '',
    group: {
      name: '',
      human: [],
      emails: []
    },
    query: {
      family: ''
    },
    messageTo: '',
    recipientList: [],
    familyResult: [],
    agencyResult: [],
    conversationIndex: '',
    rules: {
      NameRule: (v) => !!v || 'Please enter Group Name',
      toRule: (v) => !!(v && v.length) || 'Please select recipient',
      multipleEmail: (v) => v === undefined || v.length === 0 || /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/.test(v) || 'Please enter valid email address'
    },    
  }),
  computed: {
    ...mapGetters(['Agency', 'MessageGroup']),
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    }
  },  
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.initializeAgencyList();
    this.initializeMessageGroup(); 
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
    this.$refs.messageRef.scrollIntoView({ behavior: 'smooth' });
  },
  methods: {
    async initializeMessageGroup () {
      if (!this.MessageGroup.length) {
        let { error, data } = await getCollection(this.entity, true);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setMessageGroup', data);
          }
        }
      }
    },
    removeItem (item) {
      this.group.human = this.group.human.filter(user => user.id !== item.id);
    },
    async save () {
      if (this.$refs.formAdd.validate()) {
        this.group.human = this.group.human.map(user => user.id);
        this.selectedData = false;
        let { error, data, status } = await create(this.entity, this.group);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.MessageGroup.push(data);
          swal.fire({
            type: 'success',
            title: 'Message Group created successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/admin/messageGroup' });
            }
          });
        }
      }
    },
    // @vuese
    // Used to search for recipients on entering family name, nickname, PPN or the agency name
    // @arg The keyup event object
    async initializeAgencyList () {
      if (!this.AgencyList.length) {
        let where = { _id: { $ne: this.Agency.id }};
        let attributes = 'name,createdAt,_id,is_admin,avatar';
        let populate = [{ path: 'human', select: '_id name user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setAgencyList', data);
          }
        }
      }
    },
    async searchFamilies () {
      this.recipientList = [];
      this.familyResult = [];
      this.agencyResult = [];
      this.query.family = this.searchInput;
      let profile_number = this.query.family;
      let profile_year = this.query.family;
      if (this.query.family && this.query.family.length > 2) {
        let where = { };
        if (this.query.family && this.query.family.length) {
          if (!where.$or) {
            where.$or = [{
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            }, {
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }, {
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }];
          } else {
            where.$or.push({
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            });
            where.$or.push({
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
          }
        }
        if (this.query.family && !isNaN(this.query.family)) {
          where.$or.push({
            'profile_number': this.query.family
          });
        }
        if (this.query.status) {
          where.profile_status = this.query.status;
        }
        let populate = [{ 'path': 'human' }, 'contactInfo.country', 'contactInfo.state'];
        let { error, data } = await getCollection('Account', true, 0, populate, where);
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            this.recipientList = data;
            this.agencyFilter();
          } else {
            this.agencyFilter();
          }
        }
      }
    },
    async agencyFilter () {
      if (this.query.family && this.query.family.length > 2) {
        let filteredList = this.AgencyList.filter((element) => {
          if (element.name.toLowerCase().includes(this.query.family.toLowerCase())) {
            return element;
          }
          return false;
        });
        if (this.recipientList.length) {
          this.recipientList.forEach(item => {
            let obj = {};
            if (item.nickname.toLowerCase().includes(this.searchInput.toLowerCase())) {
              obj = {
                name: item.nickname,
                id: item.human[0].id
              };
            } else {
              let text = '';
              if (item.ppn === this.searchInput) {
                text = `${item.ppn} / ${item.name}`;
              } else {
                text = item.name;
              }
              obj = {
                name: text,
                id: item.human[0].id
              };
            }
            this.familyResult.push(obj);
          });
        }
        if (filteredList.length) {
          filteredList.forEach(item => {
            let obj = {
              name: item.name,
              id: item.human[0].id
            };
            this.agencyResult.push(obj);
          });
        }
        this.recipientList = [...this.familyResult, ...this.agencyResult];
      }
    },
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/admin/messageGroup' });
    }     
  }
};
</script>

<style lang="css" scoped>
  .editor-button-container{
    padding-top: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Messages/group_add.vue